module.exports = __webpack_public_path__ + "static/media/MHRM84N0002.a21cf638.svg";